import { apiClient } from '../../axios';
import { RegulationResponse } from './types';

export const getRegulationApi = () => apiClient.get<RegulationResponse>('/v1/user/regulation');
